import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { can_delete_selected_objects } from '../../lattice';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { uil_delete_selected_objects } from '../../ui_logic';
import { shift_pressed } from '../../keypress';
import delete_svg from '../../../assets/img/SVG_icons/Top/create_model/delete.svg';
import { img } from '@phi/components';
import DeleteObjectsTooltip from './DeleteObjectsTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const DeleteIcon = delete_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Delete objects';
        },

        disabled() {
            return !this.state.loaded
                || this.total_selected_objects === 0
                || !can_delete_selected_objects()[0];
        },

        total_selected_objects() {
            return this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
        }
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uil_delete_selected_objects(shift_pressed());
        },

        onLongClick() {
            if (this.disabled)
                return;
            else
                uil_delete_selected_objects(true);
        },
    },

    render() {
        return h(BarButton, {
            id: 'delete-objects-button',
            wrapperId: 'delete-objects-wrapper',
            onClick: this.onClick,
            active: false,
            selected: this.state.tut_stage === 6,
            disabled: this.disabled,
            tippy: 'left',
            long: true,
            onLongClick: this.onLongClick,
            help: 'delete_objects',
        }, {
            label: () => 'Delete',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(delete_svg, this.alt),
            tooltip: DeleteObjectsTooltip,
        });
    },
});
